module.exports = __webpack_public_path__ + "img/editIncidentLocation.aa4b2bef.svg";